'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CardHeaderSecondaryTextBoxStyled = undefined;

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/** Styles */
var CardHeaderSecondaryTextBoxStyled = exports.CardHeaderSecondaryTextBoxStyled = _styledComponents2.default.div.withConfig({
  displayName: 'CardHeaderSecondaryTextBoxStyled'
})(['display:flex;flex-direction:column;justify-content:center;']);

CardHeaderSecondaryTextBoxStyled.displayName = 'CardHeaderSecondaryTextBoxStyled';


//////////////////
// WEBPACK FOOTER
// ./~/reactackle-card/dist/CardHeaderSecondary/styles/CardHeaderSecondaryTextBoxStyled.js
// module id = 602
// module chunks = 0